import { ThunkDispatch } from "@reduxjs/toolkit";
import React from 'react';
import { connect, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import { ImageEditingState } from '../../reducers/imageEditing';

import ImageEditingAIPanel from './ImageEditingAIPanel';
import ImageEditingHistoryPanel from './ImageEditingHistoryPanel';
import ImageEditingMainArea from './ImageEditingMainArea';
import ImageEditingSettingsPanel from './ImageEditingSettingsPanel';

// State型定義
interface RootState {
  imageEditing: ImageEditingState;
  currentUser: {
    planType?: string;
  };
  [key: string]: any;
}

// mapStateToPropsの型定義
function mapStateToProps(state: RootState) {
  return {
    processingMethod: state.imageEditing.processingMethod,
    planType: state.currentUser.planType
  };
}

// コンポーネントのProps型定義
interface ImageEditingFormSomeProps {
  processingMethod: 'single' | 'individual';
  planType?: string;
}

const ImageEditingFormSome: React.FC<ImageEditingFormSomeProps> = (props) => {
  const { processingMethod, planType } = props;
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  const navigate = useNavigate();

  // AI加工機能が利用可能なプラン
  const AI_PROCESSING_ALLOWED_PLANS = ['Basic', 'Pro', 'Custom', 'Elite', 'Enterprise'];
  const canUseAIProcessing = planType && AI_PROCESSING_ALLOWED_PLANS.includes(planType);

  return (
    <div className="h-[calc(100vh-220px)] overflow-hidden">
      <div className="flex gap-4 px-4 py-2" style={{ height: 'calc(100vh - 220px - 1rem)' }}>
        {/* 左列：設定パネル */}
        <div className="flex-none w-[250px] overflow-visible">
          <ImageEditingSettingsPanel />
        </div>

        {/* 中央列：メインエリア + AI加工パネル */}
        <div className="flex-1 min-w-0 flex flex-col overflow-hidden" style={{ height: '100%' }}>
          <div className="flex-1 min-h-0 overflow-hidden">
            <ImageEditingMainArea />
          </div>

          {/* AI加工パネル - 個別処理モードで常に表示（プラン制限はパネル内で制御） */}
          {processingMethod === 'individual' && (
            <div className="flex-shrink-0 py-3">
              <ImageEditingAIPanel canUseAIProcessing={canUseAIProcessing} />
            </div>
          )}
        </div>

        {/* 右列：履歴パネル - 個別処理モードで常に表示（プラン制限はパネル内で制御） */}
        {processingMethod === 'individual' && (
          <div className="flex-shrink-0 flex flex-col overflow-hidden" style={{ width: '400px', minWidth: '400px', maxWidth: '400px', height: '100%' }}>
            <ImageEditingHistoryPanel canUseAIProcessing={canUseAIProcessing} />
          </div>
        )}
      </div>
    </div>
  );
};

export default connect(mapStateToProps)(ImageEditingFormSome);